import Link from "next/link";
import { TextArea } from "../../component/design-system/shared-styles/StyledForm";
import ChoosePickupOption from "./choosePickupOption";
import HowPickUpWorks from "./how-pickup-works";
import HowToReturn from "./how-to-return";
import WhyNoPickupInMyArea from "./no-pickup-in-myarea";

export const FAQ = [
  {
    heading: "How Does Pick Up Work?",
    content: <HowPickUpWorks />,
  },

  {
    heading: "Why is no Pick Up available in my area?",
    content: <WhyNoPickupInMyArea />,
  },

  {
    heading: "Should I choose Pick Up or Ship to Home Option?",
    content: <ChoosePickupOption />,
  },

  {
    heading: "When and how can I return the product?",
    content: <HowToReturn />,
  },

  {
    heading: "When can I pick up my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        You will receive a confirmation email letting you know when your order
        is ready for pick-up.
      </TextArea>
    ),
  },

  {
    heading: "What do I need to bring to pick-up my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        You may present yourself in-store at the Customer Service counter with a
        photo ID and the email confirmation you received in order to pick up
        your order.
      </TextArea>
    ),
  },

  {
    heading: "Who can pick up my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        The person whose contact information appears on their order is the only
        person who is authorized to pick it up.
      </TextArea>
    ),
  },

  {
    heading: "How do I change my pick-up location?",
    content: (
      <TextArea style={{ margin: "0" }}>
        Once the order is placed, the pick-up location cannot be changed. Please
        contact customer service for more assistance.
      </TextArea>
    ),
  },

  {
    heading: "How long do I have to pick up my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        You have one week to pick up your order once you have received your
        pick-up confirmation email. If the order is not picked up within this
        timeline, the store will contact you to make other arrangements.
      </TextArea>
    ),
  },

  {
    heading:
      "Can I choose to have some items shipped and others picked up at a store?",
    content: (
      <TextArea style={{ margin: "0" }}>
        You would have to place two different orders, one for in-store pickup
        and the other to be shipped.
      </TextArea>
    ),
  },

  {
    heading: "When will my credit card be charged?",
    content: (
      <TextArea style={{ margin: "0" }}>
        The full order total will be charged to your account once you have
        received the confirmation email that your order is ready for pick-up.
      </TextArea>
    ),
  },

  {
    heading:
      "What should I do if I don’t receive a pick-up confirmation email?",
    content: (
      <TextArea style={{ margin: "0" }}>
        Contact customer service by phone, email or LiveChat for more
        information.

        <b>Click Here</b>
      </TextArea>
    ),
  },

  {
    heading: "How do I change or cancel my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        Contact customer service by phone, email or LiveChat for more
        information.

        <Link
          href="/contact-us-for-car-parts"
          prefetch={false}
        >

          Click Here
        </Link>
      </TextArea>
    ),
  },

  {
    heading: "Can I return or exchange my order in-store?",
    content: (
      <TextArea style={{ margin: "0" }}>
        Please refer to our Return Policy for more information.

        <Link
          href="/contact-us-for-car-parts"
          prefetch={false}
        >

          Click Here
        </Link>
      </TextArea>
    ),
  },

  {
    heading: "Where in-store should I go to pick up my order?",
    content: (
      <TextArea style={{ margin: "0" }}>
        Present yourself at the Customer Service counter to pick up your order.
      </TextArea>
    ),
  },
];

export const STORESMORELOCATIONS = [
  {
    stateName: "Alberta",
    cities: ["Calgary", "Edmonton", ""],
  },
  {
    stateName: "British Columbia",
    cities: ["Vancouver", "Surrey", "Burnaby"],
  },
  {
    stateName: "Manitoba",
    cities: ["Winnipeg", "Brandon", "Springfield"],
  },
  {
    stateName: "New Brunswick",
    cities: ["Moncton", "Saint John", "Fredericton"],
  },
  {
    stateName: "Nova Scotia",
    cities: ["Halifax", "Sydney", "Lunenburg"],
  },
  {
    stateName: "Ontario",
    cities: ["Greater Toronto Area", "Ottawa", "Hamilton"],
  },
  {
    stateName: "Quebec",
    cities: ["Montreal", "Quebec City", "Laval"],
  },
  {
    stateName: "Saskatchewan",
    cities: ["Saskatoon", "Regina", "Prince Albert"],
  },
  {
    stateName: "Northwest Territories",
    cities: ["Yellowknife", "Hay River", ""],
  },
  {
    stateName: "Nunavut",
    cities: ["Iqaluit", "Arviat", ""],
  },
  {
    stateName: "Yukon Auto",
    cities: ["Whitehorse", "Dawson City", ""],
  },
  {
    stateName: "Prince Edward Island",
    cities: ["Charlottetown", "Summerside", ""],
  },
  {
    stateName: "Newfoundland",
    cities: ["St. John’s", "Conception Bay South", "Mount Pearl"],
  },
];
